import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject, Subscription } from 'rxjs';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { InstanceDataService } from 'src/app/services/instance-data.service';
import { OrganizationDataService } from 'src/app/services/organization-data.service';
import { ManagementApiService } from '../../../../../services';
import { CustomToastService } from '../../../../../services/custom-toast.service';
import { GlobalEmittersService } from '../../../../../services/global-emitters.service';
import { UserUtilityService } from '../../../../../services/user-utility.service';
import { AppConstants } from 'src/app/constants/appconstants';
import { HierarchyViewModel } from 'src/app/Modules/idms/models/hierarchy-view.model';
import { TaggedItemType, ViewDto } from '../../../models/instance/instance.model';
import { takeUntil } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogComponent } from 'src/app/shared/info-dialogs/confirmation-dialog/confirmation-dialog.component';

@Component({
    selector: 'app-instance-views-hierarchy',
    templateUrl: './instance-views-hierarchy.component.html',
    styleUrls: ['./instance-views-hierarchy.component.scss'],
    standalone: false
})
export class InstanceViewsHierarchyComponent implements OnInit, OnDestroy {
    destroy$ = new Subject();

    instanceNameSubscription: Subscription;
    assetTypeSubscription: Subscription;
    assetTypeIdSubscription: Subscription;
    queryParamsSubscription: Subscription;
    currentOrganizationName: string;
    instanceId: string;
    EditinstanceId: string;
    isSaveOnce: boolean = true;
    assetTypeId: string;
    idmsHierarchy: HierarchyViewModel[];
    idmstagItem: HierarchyViewModel[];
    checkHierchyResponse: HierarchyViewModel[];
    currentInstanceIdSubscription: Subscription;
    selectedHierarchy: any;
    isCreate: boolean;
    idmsView: HierarchyViewModel[] | ViewDto[];
    isSaved: boolean = false;
    resultList: HierarchyViewModel[] = [];
    isAllowEdit: boolean;
    isCustomClick: boolean = false;
    dropDownList: HierarchyViewModel[];
    customHiearchy: HierarchyViewModel;
    isCustomOnce: boolean = false;
    diagramJson: any;
    taggedItemsTypes: TaggedItemType[];

    constructor(
        private organizationDataService: OrganizationDataService,
        private instanceDataService: InstanceDataService,
        private activatedRoute: ActivatedRoute,
        private cd: ChangeDetectorRef,
        private ngxUiLoaderService: NgxUiLoaderService,
        private mgmtApi: ManagementApiService,
        private user_utility: UserUtilityService,
        private globalEmittersService: GlobalEmittersService,
        private customToastService: CustomToastService,
        private modelService: NgbModal
    ) {
        this.idmsView = [];
        this.EditinstanceId = this.activatedRoute.snapshot.paramMap.get('id');
        if (this.EditinstanceId) {
            this.isSaved = true;
            this.isSaveOnce = false;
        }
        this.isAllowEdit = false;
    }

    async ngOnInit(): Promise<void> {
        const viewHierarchy = await this.user_utility.checkUserPermissionDataAndRoute('view-hierarchy', userActions.View);
        this.isAllowEdit = await this.user_utility.checkUserPermissionDataAndRoute('view-modify', userActions.Edit);
        this.instanceDataService.instanceActiveTab.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res == AppConstants.tab_viewHierarchy && viewHierarchy) {
                this.initializeComponent();
            }
        });
        this.handleSubscription();
    }

    async handleSubscription() {
        if (this.isAllowEdit) {
            this.globalEmittersService.taggedItemAllowEdit.next(this.isAllowEdit); // * used in  taggedItemEdit modal
        }

        this.instanceDataService.instanceTabNext.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp == AppConstants.tab_viewHierarchy) {
                this.nextClick();
            }
        });

        this.instanceDataService.instanceTabBack.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp == AppConstants.tab_viewHierarchy) {
                this.navigateBack();
            }
        });
    }

    // * helper method to load component
    initializeComponent() {
        if (this.activatedRoute.snapshot.paramMap.get('id')) {
            // * view's in edit mode
            this.GetHierarchyTemplatesByInstance();
            this.isCreate = false;
        } else {
            // * views while creating an instance
            this.instanceId = this.instanceDataService.instanceDetails.instanceId;
            this.getViewTemplates();
            this.isCreate = true;
        }
        this.initializeSubscriptions();
    }

    // * api call to get the hierarchy templates
    async GetHierarchyTemplates() {
        if (!this.dropDownList?.length) {
            let result = await this.mgmtApi
                .GetHierarchyTemplates(this.assetTypeId || this.instanceDataService.instanceDetails.instanceAssetType.instanceAssetTypeId)
                .toPromise();

            this.ngxUiLoaderService.stop();
            if (result.success === true) {
                this.dropDownList = result.response;
                this.idmsHierarchy = result.response;
                if (this.dropDownList?.length == 1) {
                    this.idmstagItem = result.response;

                    this.selectedHierarchy = this.idmstagItem[0].name;
                    this.selectedHierarchy = this.idmstagItem[0];
                    this.HierarchyChange();

                    // this.HierarchyChange(this.idmstagItem[0]);
                } else {
                    this.idmstagItem = [];
                    this.selectedHierarchy = '';
                }
            } else {
                this.user_utility.errorModelPopup(result.message);
            }
        }
    }

    // * api call to get the hierarchy template by instance
    async GetHierarchyTemplatesByInstance() {
        if (!this.idmstagItem?.length) {
            await this.GetHierarchyTemplatesByInstanceApicall();
        }
    }

    async GetHierarchyTemplatesByInstanceApicall() {
        try {
            this.ngxUiLoaderService.start();

            let result = await this.mgmtApi.GetHierarchyTemplatesByInstance(this.EditinstanceId || this.instanceId).toPromise();

            if (result.success === true) {
                this.idmsHierarchy = result.response;
                this.idmstagItem = result.response;
                this.checkHierchyResponse = result.response;
                this.cd.detectChanges();
                if (!result.response.length) {
                    this.getViewTemplates();
                    this.GetHierarchyTemplates();
                    this.isSaveOnce = true;
                    this.isCreate = true;
                    this.isSaved = false;
                } else {
                    this.isSaved = true;
                }
                this.ngxUiLoaderService.stop();
            } else {
                this.ngxUiLoaderService.stop();
                this.user_utility.errorModelPopup(result.message);
            }
        } catch (e) {
            this.ngxUiLoaderService.stop();
        }
    }
    // * helper for navigation
    navigateBack() {
        this.instanceDataService.instanceNavigationHandler(6);
    }

    // * helper for navigation
    cancelButtonClick() {
        this.instanceDataService.instanceNavigationHandler(6);
    }

    // * helper method to get the default views
    async getViewTemplates() {
        try {
            if (!this.idmsView?.length) {
                this.ngxUiLoaderService.start();
                let result = await this.mgmtApi.getViewTemplates().toPromise();

                if (result.success === true) {
                    this.idmsView = result.response;
                } else {
                    this.user_utility.errorModelPopup(result.message);
                }
                this.ngxUiLoaderService.stop();
            }
        } catch (e) {
            this.ngxUiLoaderService.stop();
        }
    }

    // * helper method to generate the API payload
    makingResultArray() {
        this.idmsView?.map((x) => {
            x.hierarchy = this.resultList[0];
        });
    }

    // * handler for next button click
    async nextClick() {
        if (this.idmstagItem && this.idmstagItem.length > 0 && this.idmstagItem[0]) {
            if (this.isCreate) {
                if (!this.isSaved) {
                    this.makingResultArray();

                    try {
                        this.ngxUiLoaderService.start();
                        // * removing hierarchy where isDefault marked as false
                        this.idmsView.forEach((view, index) => {
                            if (!view.isDefault) {
                                delete view.hierarchy;
                            }
                        });
                        let response = await this.mgmtApi.updateIdmsView(this.instanceId, this.idmsView).toPromise();

                        if (response.success) {
                            this.isSaved = true;
                            this.customToastService.successToast('View created successfully', 'Success');
                            this.ngxUiLoaderService.stop();
                            this.idmstagItem = response.response;
                            this.idmsHierarchy = response.response;
                            this.isCreate = false;
                            this.isSaveOnce = false;
                            await this.GetHierarchyTemplatesByInstanceApicall();
                            // this.cd.detectChanges();
                            this.instanceDataService.instanceNavigationHandler(7);
                        } else {
                            this.isSaved = false;
                            this.ngxUiLoaderService.stop();
                            this.customToastService.errorToast('Error while create View', 'Error');
                        }
                    } catch (e) {
                        this.isSaved = false;
                        this.ngxUiLoaderService.stop();
                        this.customToastService.errorToast('Error while create View', 'Error');
                    }
                } else {
                    this.instanceDataService.instanceNavigationHandler(7);
                }
            } else {
                if (!this.isSaved || this.resultList.length > 0) {
                    try {
                        this.ngxUiLoaderService.start();
                        let response = await this.mgmtApi.updateIdmsView(this.instanceId, this.idmstagItem).toPromise();

                        //this.idmstagItem = response.response;
                        if (response.success) {
                            this.isSaved = true;
                            this.customToastService.successToast('View updated successfully', 'Success');
                            this.ngxUiLoaderService.stop();
                            await this.GetHierarchyTemplatesByInstanceApicall();
                            this.instanceDataService.instanceNavigationHandler(7);
                            this.resultList = [];
                        } else {
                            this.isSaved = false;
                            this.ngxUiLoaderService.stop();
                            this.customToastService.errorToast('Error while create View', 'Error');
                        }
                    } catch (e) {
                        this.ngxUiLoaderService.stop();
                        this.isSaved = false;
                        this.customToastService.errorToast('Error while update View', 'Error');
                    }
                } else {
                    this.instanceDataService.instanceNavigationHandler(7);
                }
            }
        } else {
            // this.customToastService.errorToast('Please select hierarchy!!', 'Error');
        }
    }

    // * function to initialize necessary subscriptions
    initializeSubscriptions() {
        if (this.activatedRoute.snapshot.paramMap.get('id')) {
            this.instanceId = this.activatedRoute.snapshot.paramMap.get('id');
        }
        this.instanceDataService.currentAssetTypeId.pipe(takeUntil(this.destroy$)).subscribe((result) => {
            if (result) {
                // if(!this.checkHierchyResponse.length){this.isCreate=true}
                if (this.isCreate) {
                    this.assetTypeId = result;
                    this.GetHierarchyTemplates();
                }
            }
        });

        this.organizationDataService.currentOrganizationName.pipe(takeUntil(this.destroy$)).subscribe((orgName) => {
            this.currentOrganizationName = orgName;
        });
    }

    // * handler for hierarchy selection change
    HierarchyChange() {
        if (this.isCustomClick) {
            if (!this.customHiearchy) {
                this.isCustomOnce = false;
            }
            let dialogRef = this.modelService.open(ConfirmationDialogComponent);
            dialogRef.componentInstance.modalMessage = 'Changing the hierarchy will discard the current design. Do you want to continue?';
            dialogRef.result.then((resp) => {
                if (resp) {
                    this.isCustomClick = false;
                    this.ManageHiearchyChange();
                } else {
                    this.selectedHierarchy = null;
                }
            });
            // }
        } else {
            this.ManageHiearchyChange();
        }
    }

    ManageHiearchyChange() {
        this.resultList = [];
        if (this.idmsHierarchy?.length > 1) {
            this.idmstagItem = [];
            this.idmsHierarchy.forEach((Obj) => {
                if (Obj.name === this.selectedHierarchy.name) {
                    this.idmstagItem.push(Obj);
                }
            });
            // const obj = this.idmsHierarchy
            this.selectedHierarchy.isDefault = true;
            this.resultList.push(this.selectedHierarchy);
        } else if (this.idmsHierarchy?.length == 1) {
            this.resultList.push(this.idmsHierarchy[0]);
        }
    }

    // * api call to save the views
    saveInstanceViews(event: boolean) {
        if (event) {
            this.ngxUiLoaderService.start();
            this.mgmtApi.updateIdmsView(this.instanceId || this.EditinstanceId, this.resultList).subscribe(
                (res) => {
                    this.ngxUiLoaderService.stop();
                    if (res.success) {
                        this.customToastService.successToast('Data updated successfully', 'Success');
                        this.GetHierarchyTemplatesByInstanceApicall();
                        this.isSaveOnce = false;
                    } else if (res.isCustom) {
                        this.user_utility.errorModelPopup(res.message);
                    }
                },
                (err) => this.ngxUiLoaderService.stop()
            );
        }
    }

    updateInstanceViewAPIcall(instanceId, resultList) {
        this.mgmtApi.updateIdmsView(instanceId, resultList).subscribe(
            (res) => {
                this.ngxUiLoaderService.stop();
                if (res.success) {
                    this.resultList = [];
                    this.customToastService.successToast('View updated successfully', 'Success');
                    this.isSaveOnce = false;
                    this.GetHierarchyTemplatesByInstanceApicall();
                } else if (res.isCustom) {
                    this.user_utility.errorModelPopup(res.message);
                }
            },
            (err) => this.ngxUiLoaderService.stop()
        );
    }

    // * handle event form child component
    resultListHandler(event) {
        this.resultList = event;
        this.isSaved = false;
    }

    // * views name or selection change handler
    updateViewsSelection(event: HierarchyViewModel) {
        const index = this.resultList.findIndex((v) => v.viewId == event.viewId);
        if (index != -1) {
            this.resultList[index] = event;
        } else {
            this.resultList = [...this.resultList, event];
        }
        if (!this.isCreate) {
            this.updateInstanceViewAPIcall(this.instanceId, this.idmstagItem);
        }
    }

    async customHierarchy() {
        this.isCustomClick = true;
        this.isCustomOnce = true;
        this.selectedHierarchy = null;
        this.ngxUiLoaderService.start();
        let taggedItemTypes = await this.mgmtApi.taggeditemtypes().toPromise();
        if (taggedItemTypes.success) {
            this.taggedItemsTypes = taggedItemTypes.response;
        } else {
            this.user_utility.errorModelPopup(taggedItemTypes.message);
        }
        this.ngxUiLoaderService.stop();
    }

    UseHierarchy() {
        this.isCustomOnce = true;
        this.globalEmittersService.useHiearchyClick.next(true);
    }

    genratedHierarchy(event) {
        this.customHiearchy = {
            name: 'Custom Hierarchy',
            connectorHierarchy: event.data,
        };

        this.resultList = [];
        this.idmstagItem = [];
        this.idmsHierarchy.forEach((x) => {
            if (x.name == this.customHiearchy.name) {
                x = this.customHiearchy;
            }
        });
        let index = this.idmsHierarchy.findIndex((x) => x.name == this.customHiearchy.name);

        if (index < 0) {
            this.idmstagItem.push(this.customHiearchy);
            this.idmsHierarchy.push(this.customHiearchy);
        } else {
            this.idmsHierarchy[index] = this.customHiearchy;
            this.idmstagItem.push(this.customHiearchy);
        }

        this.selectedHierarchy = this.customHiearchy;
        this.selectedHierarchy.isDefault = true;
        this.diagramJson = event.diagramJson;
        this.resultList.push(this.customHiearchy);
        this.isCustomClick = false;
    }

    ngOnDestroy() {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
